import { supabase } from '@/lib/supabaseClient';

const BACKEND_URL = '';

async function getAuthToken() {
  const session = await supabase.auth.getSession();
  const token = session.data.session?.access_token;

  if (!token) {
    throw new Error('Not authenticated');
  }

  return token;
}

export async function getQuickBooksConnectionStatus() {
  const token = await getAuthToken();

  const response = await fetch(`${BACKEND_URL}/api/quickbooks/status`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Failed to load QuickBooks connection status');
  }

  return data;
}

export async function connectQuickBooks() {
  const token = await getAuthToken();

  const response = await fetch(`${BACKEND_URL}/api/quickbooks/connect`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Failed to start QuickBooks connection');
  }

  return data;
}

export async function disconnectQuickBooks() {
  const token = await getAuthToken();

  const response = await fetch(`${BACKEND_URL}/api/quickbooks/disconnect`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Failed to disconnect QuickBooks');
  }

  return data;
}
